import PropTypes from "prop-types"
import { RiShareForwardLine } from "react-icons/ri"

import theme from "@/theme"

import { ShowMoreButton } from "./styled"

/**
 * This component renders a show more button with icon and text with specific styles
 *
 * @param {object} props
 * @param {string} [props.text] - The text of the button
 * @param {ReactNode} props.children - The icon of the button
 * @returns {JSX.Element}
 */
export const ShowMore = ({ text, children, ...props }) => {
  const { iconSizes } = theme
  return (
    <ShowMoreButton small rounded {...props}>
      {children ?? <RiShareForwardLine size={iconSizes.small} />}
      {text}
    </ShowMoreButton>
  )
}

ShowMore.propTypes = {
  /** Defines the text of the button */
  text: PropTypes.string,
  /** Defines the icon of the button */
  children: PropTypes.node,
}
